import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-serverdown',
  templateUrl: './serverdown.component.html',
  styleUrls: ['./serverdown.component.sass'],
  standalone: true,
  imports: [
    CommonModule
  ]
})
export class ServerdownComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
